
export default {
    name: 'BusinessRejected',
    props: {
        /**
         * A business object
         */
        business: {
            type: Object,
            required: true,
        },
        /**
         * Can the current user manage this business?
         */
        canManage: {
            type: Boolean,
            default: false,
        },
    },
};
